import home from "./home/index.js";
import company from "./company/index.js";
import searchArea from "./search/area.js";
import searchStation from "./search/station.js";
import searchSchool from "./search/school.js";
import EstateDetail from "./estate/detail.js";
import EstateIndex from "./estate/index.js";
import Voice from "./voice/index.js";
import sale from "./contact/sale.js";
import contact from "./contact/index.js";
const pages = () => {
    home();
    company();
    searchArea();
    searchStation();
    searchSchool();
    EstateDetail();
    EstateIndex();
    Voice();
    sale();
    contact();
};

export default pages;
